import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ContractorAvailabilityDto,
  ContractorAvailabilityException,
  CreateContractorAvailabilityException
} from '../models/contractor.model';
import { Shift } from '../models/shift.model';

export interface IContractorAvailabilityDataService {
  getAvailability(
    contractorId?: string
  ): Observable<ContractorAvailabilityDto[]>;

  getAvailabilityExceptions(
    contractorId?: string,
    params?: { startDate: string; endDate: string }
  ): Observable<ContractorAvailabilityException[]>;

  getShiftsForMonth(
    year: number,
    month: number,
    contractorId?: string
  ): Observable<Shift[]>;

  createAvailabilityException(
    exception: CreateContractorAvailabilityException,
    contractorId?: string
  ): Observable<ContractorAvailabilityException>;

  deleteAvailabilityException(
    exceptionId: number,
    contractorId?: string
  ): Observable<void>;
}

export const CONTRACTOR_AVAILABILITY_DATA_SERVICE =
  new InjectionToken<IContractorAvailabilityDataService>(
    'CONTRACTOR_AVAILABILITY_DATA_SERVICE'
  );
